import { UseQueryResult, useQuery } from 'react-query';
import axios, { AxiosError } from 'axios';
import { auth } from '@olo-web/utils/google/firebase';
import admin from '@olo-web/utils/google/firebase/admin';

export const getUserByEmail = async ({ email }): Promise<admin.auth.UserRecord> => {
  try {
    const idToken = await auth().currentUser.getIdToken();
    const { data } = await axios.get(`/api/users/get-by-email`, {
      params: { idToken, email },
    });
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.detail);
  }
};

export const useGetUserByEmail = (
  email: string
): UseQueryResult<admin.auth.UserRecord, AxiosError> => {
  return useQuery(['theme-auth-user', email], () => getUserByEmail({ email }), {
    staleTime: 100000,
    enabled: !!email,
    retry: 0,
  });
};
